import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { getEventsList } from "../../services/about/about.service";
import { IMAGE_BASE_URL } from "../../services/base.service";
import Title from "../../components/title";
import styles from "./about.module.css";
let unlisten;
const Events = () => {
  const [aboutList, setAboutList] = useState(null);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [tabContent, setTabContent] = useState(null);

  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "رویداد ها", url: "/events" },
    ]);
    getEventsList().then(({ data }) => {
      setAboutList((data && data.data) || []);

      const replacedImageText = data.data.rich_description.replaceAll(
        '<img src="',
        '<img src="' + IMAGE_BASE_URL + ""
      );
      setTabContent(replacedImageText);
    });
    return () => {
      try {
        unlisten();
      } catch (e) {}
    };
  }, []);
  return (
    <>
      <Title title={"رویدادها"} />
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />

        <div className={"row"}>
          <div className={"col-xs-12 col-md-8"}>
            {tabContent ? (
              <div
                id={styles.tabContent}
                className={styles.eventsTabDescription}
                dangerouslySetInnerHTML={{ __html: tabContent }}
              ></div>
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <div className={"col-xs-12 col-md-4"}>
            <h2 className={styles.sidebarAboutTitle}>رویداد ها</h2>
            {aboutList &&
            aboutList.children &&
            aboutList.children.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {aboutList.children.map((item, index) => (
                  <li key={index + "-key-tab-box"}>
                    <Link to={`/events/${item.guid}`}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Events;
